'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

/**
 * Marks Japanese pages as Japanese (<html lang="ja">) so browsers, screen readers
 * and the Japanese font rules in globals.css treat them correctly.
 */
export function HtmlLang() {
  const pathname = usePathname()
  useEffect(() => {
    document.documentElement.lang = pathname?.startsWith('/ja') ? 'ja' : 'en'
  }, [pathname])
  return null
}
